module.exports = __webpack_public_path__ + "static/kommune-von-der-frage-bis-zur-loesung-img-42d4238ec8873fa2c4a6194bd6f8adc5.jpg";